module.exports = __webpack_public_path__ + "static/media/doctor.f0592db9.svg";